import anime from 'animejs';
import Scene from '../classes/scene';
import SceneManager from '../classes/scene-manager';
import { ScrollDirection } from '../classes/scroll-manager';
import { getEl, getEls } from '../helpers';
import AnimationDebugger from '../components/animation-debugger';

export default class CustomersDependOnUs extends Scene {

	sectionSelector = '#customers-depend-on-us';
	played: boolean = false;

	constructor(manager: SceneManager, targetContainer: string) {
		super(manager, targetContainer);

		//Uncomment this to attach an animation debugger.
		//const animDebug = new AnimationDebugger(this.mediaTimeline, getEl('#intro-sequence'));

	}

	onExitedView(dir: ScrollDirection) {

	}

	onEnteredView(dir: ScrollDirection) {
		if (!this.played) {

			const els = getEls('.cdou-image .image-frame');
			for (let i = 0; i < els.length; i++) {
				let thisel = els[i];
				setTimeout(() => {
					thisel.dispatchEvent(new CustomEvent('play'));
				}, i * 200);

			}
			this.played = true;
		}
	}

}
